import React from "react";
import * as Collectors from "./collectors";

function Collector(props) {
  let { type, exercise } = props;
  type || (type = exercise.collector.type);
  const CollectorType = Collectors[`${type}`];
  return <CollectorType {...props} />;
}

export { Collector };
